import React, { Component } from "react";
import { View, TouchableOpacity, TouchableWithoutFeedback } from "react-native";
import TextView from "./TextView";
import { appStyles, loginStyles } from '../theme/styles'
import { blueDarkColor } from "../theme/colors";
import Button from "./Button";
import { wp, hp } from "../utils/responsive";

class DialogPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: props.show
        }
        this.onClose = this.onClose.bind(this)
    }

    onClose() {
        this.setState({
            show: false
        })
        this.props.onClose()
    }

    onApprove() {
        this.setState({
            show: false
        })
        this.props.onApprove()
    }
    onCancel() {
        this.setState({
            show: false
        })
        this.props.onCancel()
    }

    render() {
        return (
            this.state.show?<TouchableWithoutFeedback onPress={() => {
                    this.onClose()
                }}>
                    <View style={appStyles.modalMessageAbsolute} >
                        <View style={appStyles.modalMessageContent}>
                            {this.props.title != null && this.props.title.length > 0 ? <TextView style={{ fontSize: 20, marginBottom: 20 }}>{this.props.title}</TextView> : null}
                            <TextView style={{ textAlign: 'center', margin: 10, }}>{this.props.message}</TextView>
                            <View style={[appStyles.rowAround, { marginTop: 20, marginBottom: 20 }]}>
                                <TouchableOpacity style={[appStyles.outlineButton, {
                                    height: hp(6), borderRadius: hp(6) / 2,
                                    width: wp(20), minWidth: wp(20), alignSelf: 'center'
                                }]} onPress={() => {
                                    this.onCancel()
                                }}>
                                    <TextView style={{ color: '#C0C0C0', textAlign: 'center' }}>{this.props.cancel ? this.props.cancel : 'خیر'}</TextView>
                                </TouchableOpacity>
                                <Button
                                    text={this.props.approve ? this.props.approve : 'بلی'}
                                    style={{ paddingLeft: 20, paddingRight: 20, height: hp(6), borderRadius: hp(6) / 2, width: wp(20), marginLeft: 20 }}
                                    textStyle={[loginStyles.buttonText, { fontSize: 14 }]}
                                    onPress={() => {
                                        this.onApprove()
                                    }}
                                />

                            </View>
                        </View>
                    </View>
                </TouchableWithoutFeedback>:<View/>
        );
    }
    componentWillReceiveProps(newprops) {
        this.setState({
            show: newprops.show
        })
    }
}

export default DialogPrompt;
